module.exports = __webpack_public_path__ + "static/media/remote-jobs.0093b8e5.png";